exports.install = function (Vue, loading) {
  if (this.installed) {
    return
  }

  this.installed = true

  Vue.loading = loading

  Object.defineProperty(Vue.prototype, '$loading', {
    get: function get () { return loading }
  })
}



// WEBPACK FOOTER //
// ./src/configs/loading/plugin.js